import { type FieldConfig } from '../base/config.model';

export const enum TranslationStatus {
  /** New content not sent for translation yet */
  NotTranslated = 'Not Translated',
  /** Updated content that requires a translation review */
  UpdateRequired = 'Update Required',
  /** New content sent out for translation and with provided machine translation */
  New = 'New',
  /** Updated content that was sent out for translation with an updated machine translation */
  Updated = 'Updated',
  /** Approved content, ready to be published */
  Approved = 'Approved'
}

export interface Translation {
  id: string;
  value: string;
}

/**
 * Extension of Translation used in Page Builder context
 */
export interface PageBuilderTranslation extends Translation {
  label?: string;
  updateKey?: string | (string | number)[];
  config?: FieldConfig<any, any>;
  nodeId?: string;
  status?: TranslationStatus;
  preferredView?: 'desktop' | 'mobile' | 'tablet';
}

export const newTranslation = (value: string): Translation => ({
  id: crypto.randomUUID(),
  value
});
